export function formatDate(inputDate, format, locale) {
  let result = null;
  const date = new Date(inputDate);
  let monthType = 'short';

  if (format.includes('M')) {
    monthType = 'long';
  }

  const formatter = new Intl.DateTimeFormat(locale, {
    month: monthType,
    day: '2-digit',
    year: 'numeric',
  });
  const parts = formatter.formatToParts(date);
  const m = parts.find((p) => p.type === 'month').value;
  const d = parts.find((p) => p.type === 'day').value;
  const y = parts.find((p) => p.type === 'year').value;

  if (format === 'M d') {
    result = `${m} ${d}`;
  }

  if (format === 'MMM d') {
    result = `${m.substring(0, 3)} ${d}`;
  }

  if (format === 'Y') {
    result = `${y}`;
  }

  if (format === 'M d, Y') {
    result = `${m} ${d}, ${y}`;
  }

  if (format === 'M d,Y') {
    result = `${m} ${d},${y}`;
  }

  if (format === 'm d,Y') {
    result = `${m} ${d},${y}`;
  }

  return result;
}
